import Container from "../../../common/Container";
import ContentTextContainer from "../../../common/ContentTextContainer";
import updateDisplayService from "../../../../services/UpdateDisplayService";
import "./HelpContent.css";
import { useTranslation } from "react-i18next";

const HelpContent = () => {
    const { t } = useTranslation("helpPage");
    const { t: tEula } = useTranslation("eula");
    const { t: tPrivacyPolicy } = useTranslation("privacyPolicy");

    let displayComponent = (
        <>
            <div className="helpTopContainer">
                <h2>{t("helpQuestionTitle")}</h2>
            </div>
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("WhatIsStreamMemes")}
                text={<p>{t("WhatIsStreamMemesText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationRight={true}
                title={t("WhatAboutCopyRight")}
                text={<p>{t("WhatAboutCopyRightText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("WhyCanINotSetBits")}
                text={<p>{t("WhyCanINotSetBitsText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("CanIUseStreamMemesWhileStreaming")}
                text={<p>{t("CanIUseStreamMemesWhileStreamingText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationRight={true}
                title={t("CanIUseStreamMemesWithSLOBS")}
                text={<p>{t("CanIUseStreamMemesWithSLOBSText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("WhatIsABrowserSource")}
                text={<p>{t("WhatIsABrowserSourceText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationRight={true}
                title={t("BrowserSourceIsNotWorking")}
                text={<p>{t("BrowserSourceIsNotWorkingText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("BrowserSourceIsOffline")}
                text={<p>{t("BrowserSourceIsOfflineText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationRight={true}
                title={t("HowToImplementInTwitchStudios")}
                text={<p>{t("HowToImplementInTwitchStudiosText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("IHearTheSoundButMyViewersDoNot")}
                text={<p>{t("IHearTheSoundButMyViewersDoNotText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationRight={true}
                title={t("MyViewersHearTheSoundButIDoNot")}
                text={<p>{t("MyViewersHearTheSoundButIDoNotText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationLeft={true}
                title={t("MemesDisplayMultipleTimes")}
                text={<p>{t("MemesDisplayMultipleTimesText")}</p>}
            />
            <br />
            <ContentTextContainer
                animationRight={true}
                title={t("CanIUseStreamMemesWithLightStream")}
                text={<p>{t("CanIUseStreamMemesWithLightStreamText")}</p>}
            />
            <br />
            <div className="helpBottomContainer">
                <p>
                    {t("helpCouldNotFindAnswer", {
                        email: "support@streammemes.gg",
                    })}
                </p>
            </div>
            <div className="privacyPolicyAndEulaLinkWrapper">
                <p
                    className="privacyPolicyAndEulaLinks"
                    onClick={() => {
                        updateDisplayService.setMessage(tEula("eulaTextKey"));
                        updateDisplayService.setTitle(
                            tEula("termsOfServiceTitle"),
                        );
                        updateDisplayService.onCancel(() =>
                            updateDisplayService.clearAll(),
                        );
                    }}
                >
                    {tEula("termsOfServiceTitle")}
                </p>
                <p
                    className="privacyPolicyAndEulaLinks"
                    onClick={() => {
                        updateDisplayService.setMessage(
                            tPrivacyPolicy("privacyPolicyTextKey"),
                        );
                        updateDisplayService.setTitle(
                            tPrivacyPolicy("privacyPolicyTitle"),
                        );
                        updateDisplayService.onCancel(() =>
                            updateDisplayService.clearAll(),
                        );
                    }}
                >
                    {tPrivacyPolicy("privacyPolicyTitle")}
                </p>
            </div>
        </>
    );

    return (
        <div className="scrollableContainer">
            <Container
                content={displayComponent}
                isNoBackground={true}
                noAnimation={true}
            />
        </div>
    );
};

export default HelpContent;
